export interface ActionType{
  title: string;
  tipo: string;
}

export const UPDATE:ActionType = {
  title:"Editar Parte",
  tipo:"U"
}

export const CREATE: ActionType = {
  title:"Crear Parte",
  tipo:"I"
}

export const ADJUNTAR: ActionType = {
  title:"Adjuntar archivos",
  tipo:"A"
}

export const VALIDAR: ActionType = {
  title:"Validar Partes",
  tipo:"V"
}

export const USER_PERMISSIONS = {
  'USR':{
    'descCoste': false,
    'descFacturacion': false,
    'descFacUsuario': false,
    'descFacProvincia': false,
    'descFacExpatriados': false
  },
  'RAR':{
    'descCoste': true,
    'descFacturacion': true,
    'descFacUsuario': false,
    'descFacProvincia': false,
    'descFacExpatriados': false
  },
  'FIS':{
    'descCoste': true,
    'descFacturacion': true,
    'descFacUsuario': false,
    'descFacProvincia': true,
    'descFacExpatriados': false
  },
  'FAC':{
    'descCoste': false,
    'descFacturacion': true,
    'descFacUsuario': false,
    'descFacProvincia': true,
    'descFacExpatriados': false
  },
  'ADM':{
    'descCoste': true,
    'descFacturacion': true,
    'descFacUsuario': true,
    'descFacProvincia': true,
    'descFacExpatriados': true
  },
}

 const TITLES_FACTURACION_DOWNLOAD = {

  FACTFINAL:{
    NORMAL: 'Datos_Facturacion_Final',
    HISTORICO: 'Facturacion_Final_Historico',
  },
  FACTCP:{
    NORMAL: 'Datos_Facturacion_Por_CP',
    HISTORICO: 'Facturacion_Historico_Por_CP',
  },
  FACTUSUARIO:{
    NORMAL: 'Datos_Facturacion_Por_Usuario',
    HISTORICO: 'Facturacion_Historico_Por_Usuario',
  },
  FACPROVINCIA:{
    NORMAL: 'Datos_Facturacion_Por_Provincia',
    HISTORICO: 'Facturacion_Historico_Por_Provincia',
  }
}

const getFechaTitleFile = (fechaFacturacion:any) =>{
  const historico = fechaFacturacion!==undefined; 
	return (historico === true ? '_'+fechaFacturacion : '');
}

// export const GetTitleFileFactOficial = (fechaFacturacion:any) =>{
//   const fechaTitle = getFechaTitleFile(fechaFacturacion);
//   const fileName = (fechaTitle !== '' ? TITLES_FACTURACION_DOWNLOAD.FACTOFICIAL.HISTORICO : TITLES_FACTURACION_DOWNLOAD.FACTOFICIAL.NORMAL);
//   return `${fileName}${fechaTitle}.xlsx`;
// }

export const GetTitleFileFactFinal = (fechaFacturacion:any, soloValidados:boolean, tipoFacturacion:string) =>{
  const fechaTitle = getFechaTitleFile(fechaFacturacion);
  const fileName = (fechaTitle !== '' ? TITLES_FACTURACION_DOWNLOAD.FACTFINAL.HISTORICO : TITLES_FACTURACION_DOWNLOAD.FACTFINAL.NORMAL);
  const validados = soloValidados === true ? '_validados' : '';
  return `${fileName}_${tipoFacturacion}${fechaTitle}.xlsx`;
}

// export const GetTitleFileAsiento = (fechaFacturacion:any) =>{
//   const fechaTitle = getFechaTitleFile(fechaFacturacion);
//   const fileName = (fechaTitle !== '' ? TITLES_FACTURACION_DOWNLOAD.FACTASIENTO.HISTORICO : TITLES_FACTURACION_DOWNLOAD.FACTASIENTO.NORMAL);
//   return `${fileName}${fechaTitle}.xlsx`;
// }

export const GetTitleFileCP = (fechaFacturacion:any, soloValidados:boolean, tipoFacturacion:string) =>{
  const fechaTitle = getFechaTitleFile(fechaFacturacion);
  const fileName = (fechaTitle !== '' ? TITLES_FACTURACION_DOWNLOAD.FACTCP.HISTORICO : TITLES_FACTURACION_DOWNLOAD.FACTCP.NORMAL);
  const validados = soloValidados === true ? '_validados' : '';
  return `${fileName}_${tipoFacturacion}${fechaTitle}.xlsx`;
}

export const GetTitleFileUsuario = (fechaFacturacion:any, soloValidados:boolean, tipoFacturacion:string) =>{
  const fechaTitle = getFechaTitleFile(fechaFacturacion);
  const fileName = (fechaTitle !== '' ? TITLES_FACTURACION_DOWNLOAD.FACTUSUARIO.HISTORICO : TITLES_FACTURACION_DOWNLOAD.FACTUSUARIO.NORMAL);
  const validados = soloValidados === true ? '_validados' : '';
  return `${fileName}_${tipoFacturacion}${fechaTitle}.xlsx`;
}

export const GetTitleFileProvincia = (fechaFacturacion:any, soloValidados:boolean, tipoFacturacion:string) =>{
  const fechaTitle = getFechaTitleFile(fechaFacturacion);
  const fileName = (fechaTitle !== '' ? TITLES_FACTURACION_DOWNLOAD.FACPROVINCIA.HISTORICO : TITLES_FACTURACION_DOWNLOAD.FACPROVINCIA.NORMAL);
  const validados = soloValidados === true ? '_validados' : '';
  return `${fileName}_${tipoFacturacion}${fechaTitle}.xlsx`;
}